module.exports = __webpack_public_path__ + "static/img/inst_tm@3x.9fb3368.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/protectplus_britapro_com/images/inst_tm@3x.png
// module id = 1827
// module chunks = 0